import { useColorModeValue } from "@chakra-ui/react";
import { useTileColors } from "./tileColorUtil";

export function useDeviceTileColor() {
  // Device Overview Tile Colors reuses the same colors as fields are
  const noAlarmBgColor = useTileColors().noAlarmBgColor;
  const notAssignedBgColor = useTileColors().yellowBgColor;

  const devicesCountBgColor = useColorModeValue("#E0E7FF", "#2C3A67");

  const deviceTypeBgColor = useColorModeValue("#3182ce", "#2169acff");

  return { noAlarmBgColor, devicesCountBgColor, notAssignedBgColor, deviceTypeBgColor };
}
